import React, { useEffect, useMemo, useState } from 'react'

import styles from "./styles.module.scss"
import { CreditCardOutlined } from '@ant-design/icons'
import PartialPaymentMethodItem from './PartialPaymentMethodItem'
import AddNewItem from 'components/AddNewItem'
import { useDispatch } from 'react-redux'
import { getCustomerPaymentMethods } from 'services/guests.services'
import { Spin } from 'antd'
import { MERCHANT } from 'utils/enums'
import AddCardModal from "components/AddCardModal/AddCardModal";

export default function PartialPaymentMethods({ customerId, orderId, paymentMethod,
    setPaymentMethod, defaultPaymentMethod,
    paymentMethods = [], fetchingPaymentMethods,
    refetchPaymentMethods,
    handleUseWalletChecked,
    showWalletOption,
    wallets,
    isMobile,
    handleSubmit,
    handleCharge,
    isSplitPayment,
    transactionsHistory,
    disabled
}) {
    const dispatch = useDispatch()


    const [showAddModal, setShowAddModal] = useState(false);
    const selectedWallet = useMemo(() => {
        if (paymentMethod?.merchant === MERCHANT.Wallet) {
            return wallets?.find(wallet => wallet.walletId === paymentMethod?.paymentMethodId)
        }
        return null
    }, [wallets, paymentMethod])

    // const [paymentMethods, setPaymentMethods] = useState();
    // const [fetchingPaymentMethods, setFetchingPaymentMethods] = useState(false);


    useEffect(() => {

        if (defaultPaymentMethod)
            handlePaymentMethodChange(defaultPaymentMethod)

    }, [customerId, defaultPaymentMethod])

    function handlePaymentMethodChange(id, callback) {
        const selectedPaymentMethod = paymentMethods?.find(pm => pm.paymentMethodId === id)
        const paymentMethod = {
            merchant: selectedPaymentMethod?.type ?? MERCHANT.Stripe, // fallback to stripe
            paymentMethodId: id
        }
        setPaymentMethod(paymentMethod)
        // handle charge API
        if (callback)
            callback(paymentMethod)
    }

    function handleCashSelect(callback) {
        const paymentMethod = {
            merchant: MERCHANT.Cash
        }
        setPaymentMethod(paymentMethod)
        callback?.(paymentMethod)
    }

    function handleWalletSelect() {
        setPaymentMethod({
            merchant: MERCHANT.Wallet
        })
    }

    return (
        <div className={styles.partialPaymentMethodsContainer}>
            <div className={styles.partialPaymentMethodsLabel}>Select Payment Method</div>
            <div className={styles.partialPaymentMethodsList}>
                {
                    fetchingPaymentMethods ? <Spin /> : <>
                        {
                            paymentMethods?.map((pm) => {
                                return (
                                    <PartialPaymentMethodItem merchant={pm?.type} brand={pm?.brand}
                                        last4Digits={pm?.last4Digits}
                                        isSelected={paymentMethod?.paymentMethodId === pm?.paymentMethodId}
                                        isSplitPayment={isSplitPayment}
                                        onClick={() => {
                                            // we dont want to mistakenly pass event obj
                                            handlePaymentMethodChange(pm?.paymentMethodId)
                                        }}
                                        onApply={() => {
                                            handlePaymentMethodChange(pm?.paymentMethodId, handleCharge)
                                        }}
                                        transactions={transactionsHistory?.data?.filter(transaction => transaction?.paymentMethodId === pm?.paymentMethodId)}
                                        disabled={disabled}
                                    />
                                );
                            })
                        }
                        {
                            !isMobile &&
                            <PartialPaymentMethodItem merchant={MERCHANT.Cash}
                                isSelected={paymentMethod?.merchant === MERCHANT.Cash}
                                isSplitPayment={isSplitPayment}
                                onClick={() => { // we dont want to mistakenly pass event obj
                                    handleCashSelect()
                                }}
                                onApply={() => {
                                    handleCashSelect(handleCharge)
                                }}
                                transactions={transactionsHistory?.data?.filter(transaction => transaction.merchant === MERCHANT.Cash)}
                                disabled={disabled}
                            />
                        }
                        {
                            showWalletOption && <PartialPaymentMethodItem merchant={MERCHANT.Wallet}
                                isSelected={paymentMethod?.merchant === MERCHANT.Wallet}
                                text={selectedWallet ? `(Available Balance: $${Number(selectedWallet?.balance ?? 0).toFixed(2)})` : ""}
                                handleSubmit={handleSubmit}
                                isSplitPayment={isSplitPayment}
                                onClick={handleUseWalletChecked}
                                onApply={() => {
                                    // we are charging wallet transaction in the handleWalletCheck
                                    // thats why didn't pass the callback
                                    // handleUseWalletChecked()
                                    handleCharge({
                                        merchant: MERCHANT.Wallet,
                                        paymentMethodId: paymentMethod.paymentMethodId
                                    })
                                }}
                                transactions={transactionsHistory?.data?.filter(transaction => transaction.merchant === MERCHANT.Wallet)}
                                disabled={disabled}
                            />
                        }

                        {
                            disabled === false && <>
                                <AddNewItem
                                    text={'Add New Payment Method'}
                                    onClick={() => setShowAddModal(true)}
                                    disabled={disabled}
                                />
                                <AddCardModal
                                    customerId={customerId}
                                    visible={showAddModal}
                                    forcePrimary={paymentMethods?.length === 0}
                                    handleSave={(paymentMethod) => {
                                        refetchPaymentMethods(paymentMethod);
                                        // onSave?.(paymentMethod);
                                        setPaymentMethod({
                                            merchant: MERCHANT.Stripe,
                                            paymentMethodId: paymentMethod
                                        })
                                        setShowAddModal(false);
                                    }}
                                    onCancel={() => {
                                        setShowAddModal(false);
                                    }}
                                />
                            </>
                        }

                    </>

                }
            </div>
        </div>
    )
}
